import {
    WorkTimeReportQueryParams,
    WorkTimeReportRowDto,
} from "../models/reporting/workTimeReport";
import { SalaryItem } from "../models/workHourSalary/salaryItem";
import { apiCall } from "./apiClient";

export interface SalariesParams {
    salaryPeriodId: string;
    employeeGroupId: string;
}

export const getWorkHourSalaries = (
    params: SalariesParams,
    signal?: AbortSignal
) => {
    return apiCall<SalaryItem[]>("WorkHourSalary", "GET", params, signal);
};

export const getWorkTimeReportData = (
    params: WorkTimeReportQueryParams,
    signal?: AbortSignal
) => {
    return apiCall<WorkTimeReportRowDto[]>(
        "WorkHourSalary/WorkTimeReport",
        "GET",
        params,
        signal
    );
};
